import { callApi, PRIVATE_API_PATHS } from '../../helpers';
import { PermissionsModel } from '../reducers/permissions/permissions.types';

export const getPermissions = async (): Promise<PermissionsModel[]> => {
  return await callApi({ url: PRIVATE_API_PATHS.PERMISSIONS });
};
